import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import { LiProfileVisitsTimeframe } from "@/enum/liprofile.enum";

import { UserSchema } from "../../Users/schema/invite-user";
import { LiProfileVisitsEntrySchema } from "./liProfileVisitsEntry";

const { REQUIRED } = ERROR_TYPE;

export const LiProfileVisitsSchema = z.object({
	id: z.number(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	userId: z.number(),
	liProfileVisitsEntries: z.array(LiProfileVisitsEntrySchema).optional(),
	user: UserSchema,
	timeframe: z.nativeEnum(LiProfileVisitsTimeframe),
});

export const CreateLiProfileVisitsSchema = z.object({
	id: z.number().optional(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	userId: z.number(),
	timeframe: z.nativeEnum(LiProfileVisitsTimeframe),
	listId: z.number().min(1, { message: REQUIRED }),
});

export const UpdateLiProfileVisitsSchema = z.object({
	id: z.number(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	userId: z.number(),
	timeframe: z.nativeEnum(LiProfileVisitsTimeframe),
	listId: z.number().min(1, { message: REQUIRED }),
});

export const LiProfileVisitsResponseSchema = z.object({
	data: z.array(LiProfileVisitsSchema),
	meta: MetaDataSchema,
});

export type LiProfileVisits = z.infer<typeof LiProfileVisitsSchema>;

export type CreateLiProfileVisits = z.infer<typeof CreateLiProfileVisitsSchema>;

export type UpdateLiProfileVisits = z.infer<typeof UpdateLiProfileVisitsSchema>;

export type LiProfileVisitsResponse = z.infer<typeof LiProfileVisitsResponseSchema>;
